import _ from "lodash";

/**
 * Transforms an array of objects to the normalized form
 * @param {Array} [array] Array to normalize
 * @param {string} [keyField="id"] Name of the field that should be used as id
 * @returns {{list: {}, keys: string[]}}
 */

interface NormalizeOutput<T> {
  list: Record<number | string, any>;
  keys: T[];
}

export function normalize<KeyType = string>(array, keyField = "id") {
  return _.transform<any, NormalizeOutput<KeyType>>(
    array,
    ({ list, keys }, item) => {
      const id = item[keyField];
      list[id] = item;
      keys.push(id as KeyType);
    },
    {
      list: {},
      keys: [],
    }
  );
}
